/**
 * ID used for the `createdBy` field to indicate it was created by a system process
 */
export const CREATED_BY_SYSTEM_ID = "system";
